(function () {
  function initLimitedBatchPopover(wrapper) {
    var trigger = wrapper.querySelector('.np-lb-popover__trigger');
    var panel = wrapper.querySelector('.np-lb-popover__panel');
    if (!trigger || !panel) return;

    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var isOpen = false;
    var isPinned = false;
    var closeTimer = null;

    // Computes width/left from the WRAPPER's geometry (which never
    // overflows) and window.innerWidth, and must run — fully — before
    // the panel is ever unhidden. Measuring the panel's own rect while
    // it's shown at its naive left:0 position (which, anchored to a
    // trigger that isn't at the viewport's left edge, genuinely
    // overflows past 390px) forces a layout pass with real page
    // overflow; on a real mobile viewport that alone makes the browser
    // permanently widen window.innerWidth to fit it ("shrink to fit"
    // viewport behaviour), which then corrupts every width/overflow
    // calculation that reads window.innerWidth afterwards, including
    // this function's own correction. Doing the math against the
    // wrapper (never wider than its trigger icon, so it never
    // overflows) and applying the result before the panel paints at
    // all avoids ever producing that overflowing frame in the first
    // place.
    function positionPanel() {
      var margin = 8;
      var gap = 8;
      var panelWidth = Math.min(300, window.innerWidth - margin * 2);
      panel.style.width = panelWidth + 'px';

      var wrapperRect = wrapper.getBoundingClientRect();
      var left = 0;
      var overflowRight = wrapperRect.left + left + panelWidth - (window.innerWidth - margin);
      if (overflowRight > 0) {
        left -= overflowRight;
      }
      if (wrapperRect.left + left < margin) {
        left += margin - (wrapperRect.left + left);
      }
      panel.style.left = left + 'px';

      // Vertical: prefer opening ABOVE the trigger if there's room (so
      // it doesn't cover Add to Cart sitting below the badge); fall
      // back to below otherwise. Measuring the panel's natural height
      // needs it laid out (hidden / display:none reports 0), so it's
      // briefly shown via visibility:hidden instead of the hidden
      // attribute — width/left are already correct above, so this
      // measurement pass never produces an overflowing box (the same
      // real bug width/left is written to avoid in the first place).
      var wasHidden = panel.hidden;
      panel.hidden = false;
      panel.style.visibility = 'hidden';
      var panelHeight = panel.offsetHeight;
      panel.style.visibility = '';
      panel.hidden = wasHidden;

      var spaceBelow = window.innerHeight - wrapperRect.bottom - gap - margin;
      var spaceAbove = wrapperRect.top - gap - margin;

      if (panelHeight > spaceBelow && spaceAbove >= panelHeight) {
        panel.style.top = 'auto';
        panel.style.bottom = 'calc(100% + ' + gap + 'px)';
      } else {
        panel.style.top = 'calc(100% + ' + gap + 'px)';
        panel.style.bottom = 'auto';
      }
    }

    function cancelCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function open() {
      cancelCloseTimer();
      if (isOpen) return;
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');
      positionPanel();
      panel.hidden = false;
    }

    function close(refocus) {
      cancelCloseTimer();
      if (!isOpen) return;
      isOpen = false;
      isPinned = false;
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (refocus) trigger.focus();
    }

    // Hover opens it unpinned; a short grace delay on mouseleave bridges
    // the gap between the icon and the panel below it (mousing straight
    // down briefly leaves the wrapper's own hit box, since the panel is
    // position: absolute and doesn't enlarge it) so that transit alone
    // never closes it. A click pins it open, which this delay is also
    // what "unless it was pinned by a click" overrides, below.
    function scheduleClose() {
      cancelCloseTimer();
      closeTimer = setTimeout(function () {
        closeTimer = null;
        if (!isPinned) close();
      }, 150);
    }

    // Opening via keyboard focus or via click/tap both funnel through
    // here. For a mouse, focus fires (from the native click-focuses-
    // button behaviour) immediately before click, so open() is already
    // true by the time click's own handler runs below — meaning a bare
    // click (no prior hover) opens it unpinned here, then the click
    // handler immediately pins it. Net effect: a direct click opens AND
    // pins in one interaction, same as the hover-then-click case.
    trigger.addEventListener('focus', function () {
      open();
    });

    trigger.addEventListener('click', function () {
      if (!isOpen) {
        open();
        isPinned = true;
      } else if (!isPinned) {
        // First click after a hover-open: pin it, don't close it.
        isPinned = true;
      } else {
        // Already pinned: a second click closes it.
        close();
      }
    });

    if (hoverCapable.matches) {
      wrapper.addEventListener('mouseenter', function () {
        cancelCloseTimer();
        if (!isOpen) {
          open();
          isPinned = false;
        }
      });
      wrapper.addEventListener('mouseleave', function () {
        // Pinning (via click) is the only thing that should keep it
        // open once the mouse leaves — not also residual keyboard
        // focus, which would conflict with "a click pins it, closing
        // on mouse-away otherwise": a mouse click always pins on the
        // same interaction that focuses the button (see the click
        // handler above), so checking focus here would only ever
        // matter for the pure-keyboard-hover coincidence, at the cost
        // of silently keeping a merely-hovered (not clicked) popover
        // open against an explicit mouse-away.
        if (isPinned) return;
        scheduleClose();
      });
    }

    wrapper.addEventListener('focusout', function (event) {
      if (wrapper.contains(event.relatedTarget)) return;
      close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        close(true);
      }
    });

    document.addEventListener('click', function (event) {
      if (isOpen && !wrapper.contains(event.target)) {
        close();
      }
    });

    window.addEventListener('resize', function () {
      if (isOpen) positionPanel();
    });
  }

  function init() {
    document.querySelectorAll('.np-lb-popover').forEach(initLimitedBatchPopover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
